// extracted by mini-css-extract-plugin
export default {"Section":"connectingSection_Section__nequb","SectionTitle":"connectingSection_SectionTitle__OEcI1","SectionDescription":"connectingSection_SectionDescription__MsJFw"};